export default function Multiplication() {
  return (
    <div className="p-4">
      <h1>Multiplication</h1>
    </div>
  );
}
